export const checkIfBannerV2IsPresent = (bannerImagesV2: any) => {
  const isDesktopMediaPresent = bannerImagesV2?.desktopImage?.length > 0;
  const isTabletMediaPresent = bannerImagesV2?.tabletImage?.length > 0;
  const isMobileMediaPresent = bannerImagesV2?.mobileImage?.length > 0;

  return isDesktopMediaPresent && isTabletMediaPresent && isMobileMediaPresent;
};
